import {Question} from '@/types/content/Question';

export const Chapter2Questions: Question[] = [
  {
    headline: '第2章　中古自動車査定基準及び細則',
    introduction: '次の文章につき、正しい場合には〇、正しくない場合には×を押してください。',
    text: '査定基準価格は、原則として標準仕様の中古車が整備された状態で一般小売市場において概ね上位の価格で流通し得るものである。',
    answers: [
      {
        label: '〇',
        correct: true,
      },
      {
        label: '×',
        correct: false,
      },
    ],
    description: '査定基準価格は、定期点検整備（24ヵ月、12ヵ月）を了え、外観、機能はその年ものに見合うよう十分整備された状態にある標準仕様の中古車について、一般小売市場で概ね上位の価格（中古車が小売りされる時の標準状態）として通用するものとされています。\n\n※テキストP14　(1)査定基準価格とその設定要領を参照してください。',
    imageFilePath: null,
    exampleImageFilePath: null,
  },
  {
    headline: '第2章　中古自動車査定基準及び細則',
    introduction: '次の文章につき、正しい場合には〇、正しくない場合には×を押してください。',
    text: '車両本体におけるクラス係数について、国産車の基本クラスはⅠクラスで、輸入車の基本クラスは特クラスである。',
    answers: [
      {
        label: '〇',
        correct: false,
      },
      {
        label: '×',
        correct: true,
      },
    ],
    description: '車両本体(外装・内装、エンジン、足回り、電装）については、基本クラスを国産車ではⅢクラス、輸入車では Ⅵクラスとしています。\n\n※テキストP19　(3)車両のクラス分けとクラス係数を参照してください。',
    imageFilePath: null,
    exampleImageFilePath: null,
  },
  {
    headline: '第2章　中古自動車査定基準及び細則',
    introduction: '次の文章につき、正しい場合には〇、正しくない場合には×を押してください。',
    text: '最新式のカーナビゲーションが標準装備されていたので、加減点基準に沿って加点をおこなった。',
    answers: [
      {
        label: '〇',
        correct: false,
      },
      {
        label: '×',
        correct: true,
      },
    ],
    description: '基本価格が設定されている標準車に標準装備とされているものは加減点しません。オプション装備のものは加点対象となり、標準装備品にもかかわらず装備されていないものは、減点対象となります。\n\n※テキストP20　(7)装備品の評価を参照してください。',
    imageFilePath: null,
    exampleImageFilePath: null,
  },
];
